export default "__VITE_ASSET__BYEhFUjA__"